// Mapping between market and its dictionary keys
// for selection names
let supportedMarkets = {
    FT_ML : ["FT_ML_1", "FT_ML_2", "FT_ML_3"], // FullTime-ML
    FT_OU : ["FT_OU_1", "FT_OU_2", "FT_OU_3"], // FullTime-OU
    FT_HC : ["FT_HC_1", "FT_HC_2", "FT_HC_3"], // FullTime-HC
    DC : ["DC_1", "DC_2", "DC_3"], //Double chance
    DNB : ["DNB_1", "DNB_2"], // Draw no bet
    BTS : ["BTS_1", "BTS_2"], // Both teams to score
    TG : ["TG_1","TG_2", "TG_3"], // Total goals
    G: ["G_1","G_2","G_3"] // Games O/U (tennis)
};

// Mapping between typeId and market needed to
// handle duplicating markets with different ids
let typeIDMap = {
    //soccer
    ["0_1"]: "FT_ML",
    ["0_2"]: "FT_HC",
    ["0_3"]: "FT_OU",
    ["39_1"] : "FT_ML",
    ["39_2"] : "FT_HC",
    ["39_3"] : "FT_OU",
    ["61"]: "DC",
    ["157"]: "DNB",
    ["157_2"]: "DNB",
    ["158"]: "BTS",
    ["200_3"]: "TG",
    ["249_3"]: "TG",
    //ice hockey
    ["1222"]: "DC",
    ["1274"]: "DC",
    ["1205"]: "DNB",
    ["1272"]: "DNB",
    ["1262_3"]: "TG",
    ["1263_3"]: "TG",
    ["1227"]: "BTS",
    ["1276"]: "BTS",
    //tennis
    ["738_3"] : "G",
    ["714_3"] : "G",
};

export const constants = {
    supportedMarkets,
    typeIDMap
}
